export default {
    name: 'not-permission',
}
